import React, { useCallback, useContext } from 'react';
import { Select, SelectProps } from '@tapresearch/ui/components';

import { filterContext, FilterItemProps } from '../FilterProvider';

export interface FilterSelectProps
  extends React.PropsWithChildren<FilterItemProps & SelectProps> {
  disabled?: boolean;
}

export function FilterSelect({
  onChange = () => {
    /* do nothing*/
  },
  name,
  children,
  ...rest
}: FilterSelectProps) {
  const context = useContext(filterContext);
  const defaultValue = (context.getDefaultValueByName(name) as string) || '';

  const innerOnChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const {
        target: { value: innerValue },
      } = e;
      const label = e.target.querySelector(
        `option[value="${innerValue}"]`
      ).textContent;
      onChange(name, innerValue, label);
      context.onFilterItemChange(name, innerValue, label);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onChange, name]
  );

  return (
    <Select {...rest} onChange={innerOnChange} defaultValue={defaultValue}>
      {children}
    </Select>
  );
}
